'use strict';

module.exports = require('./es6/crc16xmodem').default;



//////////////////
// WEBPACK FOOTER
// ./~/crc/lib/crc16_xmodem.js
// module id = 762
// module chunks = 0